import * as E from 'fp-ts/lib/Either';
import {all, takeLatest, put} from 'redux-saga/effects';
import {
  ProducerCompliancePolicyAttachmentsActionType,
  loadProducerCompliancePolicyAttachments,
  getProducerCompliancePolicyAttachments,
} from 'Agent/AgentDocumentation/ducks/producerCompliancePolicyAttachments';
import * as producerCompliancePolicyAttachmentsApi from 'Agent/AgentInformation/api/producerCompliancePolicyAttachmentApi';
import {pipe} from 'fp-ts/lib/pipeable';
import {Loaded, AsyncResult} from 'Core/models/Async';
import {ProducerCompliancePolicyAttachment} from 'Agent/AgentInformation/models/ProducerCompliancePolicyAttachment';

function* getProducerCompliancePolicyAttachmentsSaga() {
  return yield takeLatest(
    ProducerCompliancePolicyAttachmentsActionType.GET_PRODUCER_COMPLIANCE_POLICY_ATTACHMENTS,
    function*(action: ReturnType<typeof getProducerCompliancePolicyAttachments>) {
      const {encryptedIdentifier} = action.payload;
      const attachments: AsyncResult<ProducerCompliancePolicyAttachment[]> = yield producerCompliancePolicyAttachmentsApi.getProducerCompliancePolicyAttachments(
        encryptedIdentifier
      );

      yield pipe(
        attachments,
        E.map(value => new Loaded(value)),
        E.fold(
          value => put(loadProducerCompliancePolicyAttachments(value)),
          value => put(loadProducerCompliancePolicyAttachments(value))
        )
      );
    }
  );
}

export default function*() {
  yield all([getProducerCompliancePolicyAttachmentsSaga()]);
}
